/**
 * DOM Patch for React Google Translate / Extension Conflict
 * Prevents "NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node"
 * and "NotFoundError: Failed to execute 'insertBefore' on 'Node'" crashes.
 */
if (typeof window !== 'undefined' && typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[DOM Patch] Prevented removeChild crash: node is not a child of this parent.', child, this);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[DOM Patch] Prevented insertBefore crash: referenceNode is not a child of this parent.', referenceNode, this);
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
